<div class="container-space-between">
  <app-page-title [title]="translations.title"></app-page-title>
</div>

<app-settings-list [allSettingGroups]="allSettingGroups()"></app-settings-list>
